module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hatch-container",
    class: _vm.customClasses
  }, [_c('div', {
    staticClass: "svg-background-left"
  }, [_c('hatch-bg')], 1), _vm._v(" "), _c('div', {
    staticClass: "svg-background-right"
  }, [_c('hatch-bg')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-559a30ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/span_background.vue
// module id = 626
// module chunks = 1